module.exports = __webpack_public_path__ + "static/media/loanagainstgold.7fb7d063.svg";